
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabintalawade() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Services in Talwade MIDC',
        heading: 'etravo : Corporate Cab and Bus Services in Talwade MIDC ',
        headingDescription: 'eTravo offers specialized Corporate Cab and Bus Services in Talwade MIDC, catering to the daily transportation needs of industrial units, factories, and corporate offices. Whether your company requires executive cab services for official travel or high-capacity buses for employee shift transportation, our solutions ensure safety, punctuality, and comfort. With a professionally maintained fleet, GPS-enabled tracking, and trained drivers, eTravo delivers efficient and reliable mobility support for businesses operating in the Talwade MIDC area.',

        top: 'Top Places to Visit in Talwade with etravo',
     "topPlaces": [
    {
      "title": "Shree Shankheshwar Parshwanath Tirth",
      "description": "A prominent Jain temple near Somatane Toll Plaza, known for its unique Kalash-shaped architecture. It's a serene place for spiritual reflection and attracts devotees from across the region."
    },
    {
      "title": "APJ Abdul Kalam Garden",
      "description": "A well-maintained public park in Talwade, offering lush greenery, walking paths, and a peaceful environment, making it ideal for morning walks and family outings."
    },
    {
      "title": "BD Garden",
      "description": "A local park providing open spaces and recreational areas for residents and visitors to relax and enjoy outdoor activities."
    },
    {
      "title": "Haribhau Seth Dinaji Vaghere Udyan",
      "description": "A community park featuring landscaped gardens and seating areas, serving as a popular spot for leisure and social gatherings."
    },
    {
      "title": "Hemu Kalani Udyan",
      "description": "A neighborhood park offering a tranquil environment with greenery and walking trails, suitable for all age groups."
    },
    {
      "title": "Jay Sitaram Udyan Rahatani Gaon",
      "description": "A family-friendly park located in Rahatani Gaon, providing playgrounds and open spaces for recreational activities."
    },
    {
      "title": "Jyotiba Udyan Kalewadi",
      "description": "A park in Kalewadi known for its serene ambiance and well-maintained gardens, ideal for relaxation and community events."
    },
    {
      "title": "Kharalai Garden",
      "description": "A local green space offering a peaceful retreat with walking paths and seating areas amidst nature."
    },
    {
      "title": "Late Gawade Oxygen Park",
      "description": "A park emphasizing environmental awareness, featuring a variety of plants and trees that contribute to the area's air quality."
    },
    {
      "title": "Rock Garden",
      "description": "A creatively designed park showcasing rock sculptures and landscaped areas, providing a unique aesthetic experience for visitors."
    }
  ],
   "services": [
    {
      "name": "Corporate Travel Solutions in Talwade MIDC",
      "description": "eTravo provides comprehensive corporate travel solutions in Talwade MIDC, catering to the diverse needs of industrial and commercial clients. Our services include tailored transport plans for daily staff commutes, executive travel, and event transportation. We combine modern vehicles, professional drivers, and technology-enabled fleet management to ensure timely, safe, and comfortable rides that support your business operations."
    },
    {
      "name": "Daily Commute Services for Talwade Employees",
      "description": "Ensure seamless daily employee transportation with eTravo’s commute services in Talwade. We offer well-coordinated cab and bus services aligned with your factory or office shift timings, covering key residential areas. Our focus is on punctuality, safety, and comfort, helping companies reduce absenteeism and improve workforce satisfaction."
    },
    {
      "name": "Cab & Bus Rentals for MIDC Companies in Talwade",
      "description": "eTravo offers flexible cab and bus rental services designed for MIDC companies operating in Talwade. Whether you need short-term hires for projects or long-term contracts for regular transport, our fleet includes AC cabs, tempo travellers, and buses of varying capacities. All vehicles are maintained to the highest standards, ensuring a hassle-free experience for both employees and management."
    },
    {
      "name": "Industrial Staff Transport Services Talwade",
      "description": "Specializing in industrial staff transport, eTravo provides reliable and efficient shuttle bus services for factories and manufacturing units in Talwade. Our transport solutions are tailored to accommodate shift rotations and large employee groups, equipped with GPS tracking and safety features for enhanced security and operational control."
    },
    {
      "name": "Reliable Office Commute Options in Talwade MIDC",
      "description": "With eTravo’s office commute services in Talwade MIDC, companies can offer dependable and comfortable transportation to their employees. Our cab and bus services cover diverse routes and schedules, backed by 24/7 support and transparent pricing. We aim to deliver stress-free travel, ensuring your workforce arrives energized and ready to perform."
    },
    {
      "name": "Air-Conditioned Corporate Buses in Talwade",
      "description": "Travel in comfort with eTravo’s air-conditioned corporate bus services in Talwade. Ideal for transporting large teams, our buses feature spacious interiors, modern amenities, and experienced drivers. Perfect for daily commutes, corporate events, or inter-facility transfers, these AC buses help businesses maintain high standards of employee welfare."
    }
  ],
  "tableData": [
    ["Corporate Travel Solutions in Talwade MIDC", "Daily Commute Services for Talwade Employees"],
    ["Cab & Bus Rentals for MIDC Companies in Talwade", "Industrial Staff Transport Services Talwade"],
    ["Reliable Office Commute Options in Talwade MIDC", "Air-Conditioned Corporate Buses in Talwade"]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Dependable Transport Services for Talwade MIDC",
        "WhyChoosedescription": "Talwade MIDC is home to a wide range of manufacturing, logistics, and tech-based industries, where timely and organized employee transport is essential. eTravo offers professional cab and bus services to meet the commuting needs of businesses in and around Talwade MIDC, ensuring on-time and efficient mobility for all shifts."
    },
    {
        "WhyChooseheading": "Versatile Fleet for Industrial Workforce and Executives",
        "WhyChoosedescription": "From executive sedans for your senior management to AC buses for your factory workforce, eTravo offers a well-maintained, safety-equipped fleet. Our vehicles are chosen to ensure comfort, durability, and efficiency, making them ideal for daily transport or special corporate movements in Talwade MIDC."
    },
    {
        "WhyChooseheading": "Trained Drivers with Area Expertise",
        "WhyChoosedescription": "Our drivers are background-verified and experienced in managing shift-based operations common in Talwade’s industrial zones. Their familiarity with the area’s factory gates, routes, and traffic schedules ensures smooth pickup and drop coordination even during high-demand hours."
    },
    {
        "WhyChooseheading": "Shift-Based and Round-the-Clock Availability",
        "WhyChoosedescription": "eTravo operates 24/7 to meet the needs of factories and industrial units with rotating or overnight shifts. Whether your operations begin at dawn or end past midnight, our corporate cab and bus services are always ready to transport your workforce safely and on time."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Corporate Billing Support",
        "WhyChoosedescription": "With eTravo, businesses in Talwade MIDC enjoy transparent pricing with zero hidden costs. We offer GST-compliant invoicing, detailed ride reports, and flexible monthly billing—ideal for companies looking to manage transport budgets with full financial clarity."
    },
    {
        "WhyChooseheading": "Safety and Hygiene Come Standard",
        "WhyChoosedescription": "Our vehicles are regularly sanitized and come equipped with essential safety features including GPS tracking, emergency kits, seat belts, and fire extinguishers. We take every measure to ensure that your employees commute in a clean, safe, and secure environment."
    },
    {
        "WhyChooseheading": "Live Ride Tracking and Responsive Support",
        "WhyChoosedescription": "With real-time GPS tracking and a responsive operations team, you stay informed about every trip. Whether it’s confirming a pickup or adjusting a route, our 24/7 support system helps your admin team manage transport logistics effortlessly."
    },
    {
        "WhyChooseheading": "Custom Transport Packages for Talwade-Based Industries",
        "WhyChoosedescription": "Every company has unique transport needs. That’s why eTravo offers tailored travel solutions—be it fixed-route employee shuttles, flexible on-demand cabs, or special transport for training events or client visits. We scale our service to fit your workforce and workflow perfectly."
    }
]
































    }

// Corporate Cab and Bus Services in Talwade MIDC – eTravo

const faqData = [
    [
        {
            question: 'What services does eTravo provide for corporate transportation in Talwade MIDC?',
            answer: 'eTravo offers dependable cab and bus services in Talwade MIDC, including employee transport, executive car rentals, shift-based pickups and drops, and corporate travel for factories and offices.',
        },
        {
            question: 'Can eTravo support shift-based transport for manufacturing companies in Talwade MIDC?',
            answer: 'Yes, eTravo specializes in managing multi-shift employee transport. We ensure timely services with optimized routes and 24/7 vehicle availability for round-the-clock operations.',
        },
        {
            question: 'What types of vehicles are available in Talwade MIDC for corporate use?',
            answer: 'Our fleet includes hatchbacks, sedans, SUVs, tempo travellers, and AC buses (13 to 50 seaters), ideal for staff commutes and executive travel within and outside Talwade MIDC.',
        },
        {
            question: 'Do your transport services include GPS tracking and safety features?',
            answer: 'Yes, all eTravo vehicles come equipped with GPS tracking, driver verification, and route compliance systems. We also offer real-time dashboards and automated reporting for HR/admin teams.',
        },
        {
            question: 'Is it possible to book vehicles for factory visits or outstation business trips?',
            answer: 'Absolutely. eTravo offers flexible booking for site inspections, vendor meetings, audits, and business travel from Talwade MIDC to various locations across Maharashtra and beyond.',
        },
        {
            question: 'Will our company get dedicated support for transport services in Talwade MIDC?',
            answer: 'Yes, every corporate client receives a dedicated account manager who oversees day-to-day operations, resolves issues, manages driver coordination, and ensures service consistency.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Arvind Satpute',
        designation: 'Admin Head, FlexoMek Industries',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s transport service in Talwade MIDC is top-notch. Their buses arrive on time, are always clean, and the drivers are disciplined and courteous.”',
    },
    {
        name: 'Ms. Meenal Desai',
        designation: 'HR Manager, Talwade Electronics Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“We’re extremely satisfied with eTravo’s employee cab and bus service. It’s reliable, scalable, and well-managed — a perfect fit for our Talwade operations.”',
    },
];











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Talwade MIDC",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-talwade-midc.jpg",
  "description": "Efficient corporate cab and bus services in Talwade MIDC by eTravo. Perfect for daily commute, staff transport for MIDC companies, and industrial employee shuttle with air-conditioned vehicles and reliable service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-talwade-midc"
  }
};






    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Services in Talwade MIDC | Staff Transport & Daily Commute | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Talwade MIDC with eTravo for daily commute, staff transport, and industrial shuttle services. Reliable and air-conditioned corporate buses available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/19.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabintalawade;